import { Injectable, inject } from '@angular/core';
import { map, Observable } from 'rxjs';
import { DictionariesCollectionService } from '@core/data/dictionaries/dictionaries-collection.service';
import { FacilitiesService } from '@core/data/providers/facilities.service';
import { Organization } from '@xt/domain-model';
import { extractOidFromUrn } from '@xt/core/utils';

@Injectable({
  providedIn: 'root',
})
export class VerificationConfigDataService {
  private readonly dictionariesCollection = inject(
    DictionariesCollectionService,
  );

  private readonly facilitiesService = inject(FacilitiesService);

  public readonly specialitiesCollection$ =
    this.dictionariesCollection.getItemById$(
      '1.2.276.0.76.11.69--20211114160337',
    );

  public readonly professionsCollection$ =
    this.dictionariesCollection.getItemById$(
      '1.2.276.0.76.11.31--20211015121326',
    );

  public readonly specialities$ = this.specialitiesCollection$.pipe(
    map(({ list }) =>
      list.map((entry) => ({
        ...entry,
        id: `${entry.id}|${entry.system}`,
      })),
    ),
  );

  public readonly professions$ = this.professionsCollection$.pipe(
    map(({ list }) => list),
  );

  public readonly countries$ = this.dictionariesCollection
    .getItemById$('taxonomytermcountry')
    .pipe(map(({ list }) => list));

  public fetchAllFacilitiesByOids(oids: string[]): Observable<Organization[]> {
    return this.facilitiesService.searchItems$({
      identifier: oids.map((oid) => extractOidFromUrn(oid)).join(', '),
    });
  }
}
